// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-J":"J_solar-60w-J__k4oip"};